export default function ReviewInferredIco() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.99271 0.529272C5.36921 -0.176458 6.38079 -0.176458 6.75729 0.529272L8.16709 3.17181C8.26043 3.34679 8.4037 3.49005 8.57868 3.5834L11.2212 4.9932C11.9269 5.3697 11.9269 6.38127 11.2212 6.75778L8.57868 8.16757C8.4037 8.26092 8.26043 8.40419 8.16709 8.57916L6.75729 11.2217C6.38079 11.9274 5.36921 11.9274 4.99271 11.2217L3.58291 8.57916C3.48957 8.40419 3.3463 8.26092 3.17132 8.16757L0.528784 6.75778C-0.176946 6.38127 -0.176947 5.3697 0.528784 4.9932L3.17132 3.5834C3.3463 3.49005 3.48957 3.34679 3.58291 3.17181L4.99271 0.529272Z"
        fill="#0070F2"
      />
    </svg>
  );
}
